import { Outlet } from 'react-router-dom';

import { Page } from '../../../components';

import ExamEventHeader from './ExamEventHeader';

export default function ExamEventLayout() {
  return (
    <Page containerClassName='flex flex-col'>
      <ExamEventHeader />
      <Outlet />
    </Page>
  );
}
